// WHAT: Shared types and context for path/breadcrumbs
// WHY:  Keep React components in .tsx file only for fast-refresh rule

// eslint-disable-next-line boundaries/element-types -- Reason: NavNode is a type definition from navigation infrastructure, not a domain-specific feature. This is a shared type dependency.
import type { NavNode } from "@/app/navigation";

import { createContext } from "react";

/**
 * State interface for path context
 *
 * @public
 *
 */

export interface PathState {
  /** Breadcrumb chain from root to current node */
  breadcrumb: NavNode[];
  /** Optional children nodes of current route */
  children?: NavNode[];
  /** Current pathname */
  pathname: string;
}

export const PathContext = createContext<PathState | undefined>(undefined);
